import { M8PartnerSortableField } from 'services/production/types';
import { PartnersTableSortableField } from 'types/state';
import { UnreachableError } from 'utils/errors';

export const normalizePartnersTableSortableField = (
  field: PartnersTableSortableField
) => ({
  toM8PartnerSortableField(): M8PartnerSortableField {
    switch (field) {
      case 'balance':
        return 'balance';
      case 'earnedAmount':
        return 'earned';
      case 'email':
        return 'email';
      case 'fullName':
        return 'lastName';
      case 'latestUpdateDate':
        return 'updatedOn';
      case 'paidAmount':
        return 'paidOut';
      case 'phone':
        return 'phone';
      case 'status':
        return 'partnerStatus';
      case 'clientsCount':
      case 'id':
        return 'id';
      default:
        throw new UnreachableError(field);
    }
  },
});
